import type {
  DistributionChannel,
  ContentMode
} from '../context/V2FiltersContext';

export const buildGlobalViewScope = (
  channel: DistributionChannel,
  contentMode: ContentMode,
  surveyYear: string
) => ({
  network: channel === 'on_trade' ? ('on' as const) : ('off' as const),
  premium_store:
    channel === 'on_trade' && contentMode === 'premium' ? true : undefined,
  survey_year: surveyYear === 'all' ? 'current' : surveyYear
});
